export const buildAverageTestDurations = (patients) => {
  const stats = new Map();

  for (const patient of patients) {
    for (const test of patient.tests || []) {
      const testName = test.testName?.trim() || "Sin nombre";
      const duration = Number(test.time ?? test.testTime);

      if (Number.isNaN(duration) || duration < 0) continue;

      const current = stats.get(testName) || { total: 0, count: 0 };
      current.total += duration;
      current.count += 1;
      stats.set(testName, current);
    }
  }

  const items = [...stats.entries()]
    .map(([testName, { total, count }]) => ({
      testName,
      averageMinutes: Math.round((total / count) * 10) / 10,
      sampleSize: count,
    }))
    .sort((a, b) => b.averageMinutes - a.averageMinutes);

  return { items };
};

export const formatDurationMinutes = (minutes) => {
  const value = Number(minutes);
  if (Number.isNaN(value)) return "—";

  if (value >= 60) {
    const hours = Math.floor(value / 60);
    const mins = Math.round(value % 60);
    return mins > 0 ? `${hours} h ${mins} min` : `${hours} h`;
  }

  return Number.isInteger(value) ? `${value} min` : `${value.toFixed(1)} min`;
};
